import UserPrepaidCardApi from '@apis/prepaid/UserPrepaidCardApi';
import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import useBottomSheet from '@hooks/ui/useBottomSheet';
import useToast from '@hooks/ui/useToast';
import {
  Dispatch, SetStateAction, useEffect, useState,
} from 'react';

import styles from './styles.module.scss';

interface Props {
    initialValue: string;
    id: string;
    name: string;
    setName: Dispatch<SetStateAction<string>>;
}

function UpdateNameBottomSheet({
  initialValue, name, setName, id,
}:Props) {
  const [inputName, setInputName] = useState<string>(initialValue);
  const { closeBottomSheet } = useBottomSheet();
  const toast = useToast();
  const updateName = () => {
    if (inputName.length === 0) {
      toast.error('카드 별명을 입력해주세요.');
      return;
    }
    UserPrepaidCardApi.updatePrepaidCardName(id, { name: inputName })
      .then(() => {
        closeBottomSheet();
        setName(inputName);
        toast.success('카드 별명이 변경되었습니다.');
      }).catch(() => {
        toast.error('오류가 발생하였습니다.');
      });
  };
  useEffect(() => {
    setInputName(name);
  }, [name]);
  return (
        <Column fullWidth spacing={40}
                className={styles.container} >
            <Column fullWidth spacing={12}>
                <Text color={colors.gray6} fontWeight='bold' size='lg'>
                    나만의 카드 별명을 입력해주세요
                </Text>
                <TextField placeholder='나만의 카드 별명을 입력해주세요'
                           value={inputName}
                           onChange={(e) => setInputName(e.target.value)} />
            </Column>
            <Button fullWidth onClick={updateName}>저장</Button>
        </Column>
  );
}

export default UpdateNameBottomSheet;
